import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Card from "../components/Card";
import Result from "../components/Result";
import { useEffect, useState } from "react";
import Loading from "../components/Loading";

export default function ResultPage() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(location);
  const image = searchParams.get("image");
  const name = searchParams.get("name");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  if (loading) {
    return <Loading />;
  }

  return (
    <Result>
      <Card img={image} name={name} result />
    </Result>
  );
}
